export const nbsLabels = {
  setupChargesDelivery: 'Charges are based on activating your device on your estimated delivery date.',
  setupCharges: 'Charges are based on activating your device today.',
  setupChargesPro: 'Charges are based on your scheduled professional install date.',
  disclaimerNextBill:
    'Your next bill estimate includes recent purchases and changes to your service. We also project your new monthly total for the bills after.',
  disclaimerActualBill:
    'Charges shown here do not include unpaid or credit balances carried over from previous bills. Your actual bill provides total costs.',
  billingChargesDfill:
    'Billing for Home Internet service starts on your estimated delivery date, which can be found on your order confirmation email.',
  billingChargesPro: 'Billing for Home Internet service starts on the day of professional setup completion.',
  billingChargesIspu: 'Billing for Home Internet service starts on the day of instore pickup.',
  nbsErrorMsg: 'Looks like something went wrong. Please wait a few minutes before trying again. Sorry for any inconvenience.',
};
